import { useRoutines } from "@/hooks/useRoutines.ts";
import { routineRowKey } from "@/shared/routines.ts";
import { RoutineRow } from "@/views/Routines.tsx";

/**
 * The routines chooser, inline in a card.
 *
 * Renders the same rows as the Routines screen, from the same `useRoutines`
 * query, so a routine toggled here shows as toggled there. Each row owns its
 * own kind-aware write, so no enable logic is duplicated.
 *
 * Rows navigate the way they do on the Routines screen, which inside a thread
 * means the canvas presents the routine rather than the browser leaving the
 * conversation: the enclosing boundary turns the row's `/settings/routines/:id`
 * into a canvas push when this card is itself a canvas layer, and into a canvas
 * reset when the card is inline in the thread. So the row needs no card-specific
 * behavior — see `CanvasNavBoundary` and `CanvasRoutineModal`.
 */
export const RoutinesPickerBody = () => {
  const { routines, isLoading } = useRoutines();

  if (isLoading) {
    return <p className="text-xs text-muted-foreground">Loading routines…</p>;
  }
  if (routines.length === 0) {
    return <p className="text-xs text-muted-foreground">No routines are available yet.</p>;
  }

  return (
    <div className="flex flex-col gap-2">
      {routines.map((routine) => (
        <RoutineRow key={routineRowKey(routine)} routine={routine} />
      ))}
    </div>
  );
};
